// auth.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private _mostrarMenu = new BehaviorSubject<boolean>(false);
  public mostrarMenu$ = this._mostrarMenu.asObservable();

  private _tipoUser = new BehaviorSubject<boolean>(false);
  public tipoUser$ = this._tipoUser.asObservable();

  constructor() {
    this.initializeAuthState();
  }

  setMostrarMenu(value: boolean): void {
    this._mostrarMenu.next(value);
  }
  
  setTipoUser(value: boolean): void {
    this._tipoUser.next(value);
  }

  initializeAuthState(): void {
    const token = sessionStorage.getItem("token");
    const tpUser = sessionStorage.getItem("tipoUser");

    if (token) {
      this.setMostrarMenu(true);
      if (tpUser === 'U') {
        this.setTipoUser(true);
      } else {
        this.setTipoUser(false);
      }
    } else {
      this.setMostrarMenu(false);
      this.setTipoUser(false);
    }
  }
}
